import { getColor } from 'helpers';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

export const DocumentsStyled = styled('div')(({ theme }) => ({
  borderRadius: 8,
  border: `1px solid ${getColor(theme, {
    dark: ColorsDark.gray150,
    light: ColorsLight.gray150,
  })}`,

  '.onboardingSuccessStatus-documentBox': {
    padding: '12px 16px',

    '&:not(:last-child)': {
      borderBottom: `1px solid ${getColor(theme, {
        dark: ColorsDark.gray150,
        light: ColorsLight.gray150,
      })}`,
    },
  },
}));
